/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">企業管理者画面</div>
            <div class="check_tbl_unit wd976 tbl_ht_none tbl_bg_blue">
                <Message v-if="validationMessage" :validationMessage="alertMessage" /><br>
                <Message :validationMessage="validationMessage" />
                <table class="senser_setting_tbl_unit wd975" >
                    <tbody>
                    <tr>
                        <th class="wd60 text_white_space" style="text-align: center" rowspan="2">区分</th>
                        <th class="wd150 text_white_space" style="text-align: center" rowspan="2">種別</th>
                        <th style="text-align: center" colspan="5">温度</th>
                        <th style="text-align: center" colspan="5">湿度</th>
                        <th class="wd60 text_white_space"  style="text-align: center" rowspan="2">wbgt値</th>
                    </tr>
                    <tr>
                        <th class="wd60 text_white_space"  style="text-align: center">上限警報</th>
                        <th class="wd60 text_white_space"  style="text-align: center">上限警報リセット</th>
                        <th class="wd60 text_white_space"  style="text-align: center">下限警報リセット</th>
                        <th class="wd60 text_white_space" style="text-align: center">下限警報</th>
                        <th class="wd60 text_white_space"  style="text-align: center">継続時間(分)</th>

                        <th class="wd60 text_white_space"  style="text-align: center">上限警報</th>
                        <th class="wd60 text_white_space"  style="text-align: center">上限警報リセット</th>
                        <th class="wd60 text_white_space"  style="text-align: center">下限警報リセット</th>
                        <th class="wd60 text_white_space" style="text-align: center">下限警報</th>
                        <th class="wd60 text_white_space"  style="text-align: center">継続時間(分)</th>
                    </tr>
                    </tbody>
                    <tbody>
                        <tr v-for="senserSettingList in senserSettingData" :key="senserSettingList.sensor_kbn_id">
                            <td v-if="senserSettingList.sensor_kbn == 0">設置型</td>
                            <td v-else-if="senserSettingList.sensor_kbn == 1">手差し型</td>
                            <td v-else-if="senserSettingList.sensor_kbn == 2">熱中症</td>

                            <td><input type="text" class="wd150" v-model="senserSettingList.sensor_kbn_name" maxlength="10"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.upper_temperature" maxlength="5"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.upper_dead_zone_temperature" maxlength="5"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.lower_dead_zone_temperature" maxlength="5"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.lower_temperature" maxlength="5"></td>

                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.duration" maxlength="4"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>

                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.upper_humidity" maxlength="5"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.upper_dead_zone_humidity" maxlength="5"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.lower_dead_zone_humidity" maxlength="5"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.lower_humidity" maxlength="5"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn == 0"><input type="text" class="wd60" v-model="senserSettingList.duration_humidity" maxlength="4"></td>
                            <td v-if="senserSettingList.sensor_kbn != 0" style="background-color: #888"></td>
                            <td v-if="senserSettingList.sensor_kbn == 2"><input type="text" class="wd60" v-model="senserSettingList.heat_stroke_threshold" maxlength="5"></td>
                            <td v-if="senserSettingList.sensor_kbn != 2" style="background-color: #888"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li>
                            <router-link class="checkSetting_buttan_unit" :to="{ name: 'managemenu'} ">キャンセル</router-link>
                        </li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="sendSenSerSetting">更新</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit">センサー閾値登録</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>センサー閾値登録が完了しました。</p>
                    </div>

                    <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel">OK</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import ValidationRule from '@/app/config/validationRule.js'
    import Message from '@/app/components/Message.vue'
export default {
    name: 'SenserSetting',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            isLoading:false,
            isInitLoading:true,
            validationMessage:'',
            alertMessage:'入力エラーがあります。',
            senserSettingData:[
                {sensor_kbn_id:null,sensor_kbn_name:null,sensor_kbn:null,upper_temperature:'',lower_temperature:'',upper_dead_zone_temperature:''
                ,lower_dead_zone_temperature:'',duration:'',upper_humidity:'',lower_humidity:'',upper_dead_zone_humidity:''
                ,lower_dead_zone_humidity:'',duration_humidity:'',heat_stroke_threshold:''}
            ],
            showContent:false,
            sensorKbnSettings: []
        }
    },
    computed:{
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
    },
    created: function(){
        this.calc();
    },
    methods:{
        async calc(){

            //機器閾値情報取得API
            var brandId = this.$store.getters['brand/id'];
            var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/measuring_instruments_threshold/setting';

            // API処理判定
            var apiResponseFlg = true;

            await this.$axios
                .get(url)
                .then(response => (this.sensorKbnSettings = response.data.sensorKbnSettings))
                .catch((err)=> {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);

            // API処理判定
            if(!apiResponseFlg){
                return null;
            }

            //データの詰め替え
            let itemList = [];
            //ヘッダーのID設定を追加
            for(var k = 0 ; k < 7 ; k++){
                var inpuotApiDataObj = new Object();
                inpuotApiDataObj['sensor_kbn_id'] = this.sensorKbnSettings[k].sensorKbnId;
                inpuotApiDataObj['sensor_kbn_name'] = this.sensorKbnSettings[k].sensorKbnName;
                inpuotApiDataObj['sensor_kbn'] = this.sensorKbnSettings[k].sensorKbn;
                inpuotApiDataObj['upper_temperature'] = this.sensorKbnSettings[k].upperTemperature;
                inpuotApiDataObj['lower_temperature'] = this.sensorKbnSettings[k].lowerTemperature;
                inpuotApiDataObj['upper_dead_zone_temperature'] = this.sensorKbnSettings[k].upperDeadZoneTemperature;
                inpuotApiDataObj['lower_dead_zone_temperature'] = this.sensorKbnSettings[k].lowerDeadZoneTemperature;
                inpuotApiDataObj['duration'] = this.sensorKbnSettings[k].duration;

                inpuotApiDataObj['upper_humidity'] = this.sensorKbnSettings[k].upperHumidity;
                inpuotApiDataObj['lower_humidity'] = this.sensorKbnSettings[k].lowerHumidity;
                inpuotApiDataObj['upper_dead_zone_humidity'] = this.sensorKbnSettings[k].upperDeadZoneHumidity;
                inpuotApiDataObj['lower_dead_zone_humidity'] = this.sensorKbnSettings[k].lowerDeadZoneHumidity;
                inpuotApiDataObj['duration_humidity'] = this.sensorKbnSettings[k].durationHumidity;
                inpuotApiDataObj['heat_stroke_threshold'] = this.sensorKbnSettings[k].heatStrokeThreshold;

                itemList.push(inpuotApiDataObj);
            }
            this.senserSettingData = itemList;

        },
        async sendSenSerSetting(){

            this.isLoading = true;
            var apiResponseFlg = true;

            //エラー内容初期化
            this.clearError();

            let senserDataList = [];
            senserDataList = this.senserSettingData;

            // 必須チェック
            for(var i = 0 ; i < senserDataList.length ; i++) {

                // (温度)警報または警報リセットが入力されている場合は、継続時間も必須とする。
                if(((senserDataList[i].upper_temperature || senserDataList[i].upper_dead_zone_temperature) ||
                    (senserDataList[i].lower_temperature || senserDataList[i].lower_dead_zone_temperature) ) &&
                    (senserDataList[i].duration === null || senserDataList[i].duration == undefined || senserDataList[i].duration === "")){
                    this.isLoading = false;
                    this.validationMessage = '継続時間(分)を入力してください。';
                    this.scrollTop();
                    return null;
                }

                //(湿度) 警報または警報リセットが入力されている場合は、継続時間も必須とする。
                if(((senserDataList[i].lower_humidity || senserDataList[i].lower_dead_zone_humidity) ||
                    (senserDataList[i].upper_humidity || senserDataList[i].upper_dead_zone_humidity)) &&
                    (senserDataList[i].duration_humidity === null || senserDataList[i].duration_humidity == undefined || senserDataList[i].duration_humidity === "")){
                    this.isLoading = false;
                    this.validationMessage = '継続時間(分)を入力してください。';
                    this.scrollTop();
                    return null;
                }

                // (温度)継続時間が入力されている場合は、上限または下限も必須とする。(温度)
                if(senserDataList[i].duration !== null && senserDataList[i].duration !== "" ){
                    if((!senserDataList[i].upper_temperature && !senserDataList[i].upper_dead_zone_temperature) &&
                        (!senserDataList[i].lower_temperature && !senserDataList[i].lower_dead_zone_temperature)){
                        this.isLoading = false;
                        this.validationMessage = '温度 上限警報、上限警報リセットまたは下限警報、下限警報リセットを入力してください。';
                        this.scrollTop();
                        return null;
                    }
                    // 上限警報、上限警報リセットいずれかの入力しかない場合
                    else if((!senserDataList[i].upper_temperature && senserDataList[i].upper_dead_zone_temperature) ||
                        (senserDataList[i].upper_temperature && !senserDataList[i].upper_dead_zone_temperature)){
                        this.isLoading = false;
                        this.validationMessage = '温度 上限警報、上限警報リセットはセットで入力してください。';
                        this.scrollTop();
                        return null;
                    }
                    // 下限警報、下限警報リセットいずれかの入力しかない場合
                    else if((!senserDataList[i].lower_temperature && senserDataList[i].lower_dead_zone_temperature) ||
                        (senserDataList[i].lower_temperature && !senserDataList[i].lower_dead_zone_temperature)){
                        this.isLoading = false;
                        this.validationMessage = '温度 下限警報、下限警報リセットはセットで入力してください。';
                        this.scrollTop();
                        return null;
                    }

                }

                // (湿度)継続時間が入力されている場合は、上限または下限も必須とする。(湿度)
                if(senserDataList[i].duration_humidity !== null && senserDataList[i].duration_humidity !== ""){

                    if((!senserDataList[i].upper_humidity && !senserDataList[i].upper_dead_zone_humidity) &&
                        (!senserDataList[i].lower_humidity && !senserDataList[i].lower_dead_zone_humidity)){
                        this.isLoading = false;
                        this.validationMessage = '湿度 上限警報、上限警報リセットまたは下限警報、下限警報リセットを入力してください。';
                        this.scrollTop();
                        return null;
                    }
                    // 上限警報、上限警報リセットいずれかの入力しかない場合
                    else if((!senserDataList[i].upper_humidity && senserDataList[i].upper_dead_zone_humidity) ||
                        (senserDataList[i].upper_humidity && !senserDataList[i].upper_dead_zone_humidity)){
                        this.isLoading = false;
                        this.validationMessage = '湿度 上限警報、上限警報リセットはセットで入力してください。';
                        this.scrollTop();
                        return null;
                    }
                    // 下限警報、下限警報リセットいずれかの入力しかない場合
                    else if((!senserDataList[i].lower_humidity && senserDataList[i].lower_dead_zone_humidity) ||
                        (senserDataList[i].lower_humidity && !senserDataList[i].lower_dead_zone_humidity)){
                        this.isLoading = false;
                        this.validationMessage = '湿度 下限警報、下限警報リセットはセットで入力してください。';
                        this.scrollTop();
                        return null;
                    }
                }
            }

            //文字種
            for(var k = 0 ; k < senserDataList.length ; k++) {
                if(!this.checkStrong(senserDataList[k].sensor_kbn_name)){
                    this.isLoading = false;
                    this.validationMessage = '種別は 英数漢ひらカタ のみ使用できます。';
                    this.scrollTop();
                    return null;
                }

                // 手差しは対象から除外
                if(senserDataList[k].sensor_kbn == 0){
                    if(!this.checkStrong2(senserDataList[k].upper_temperature) || !this.checkStrong2(senserDataList[k].upper_humidity)){
                        this.isLoading = false;
                        this.validationMessage = '上限警報は 数字、記号「.」「-」 のみ使用できます。';
                        this.scrollTop();
                        return null;
                    }
                    if(!this.checkStrong2(senserDataList[k].lower_temperature) || !this.checkStrong2(senserDataList[k].lower_humidity)){
                        this.isLoading = false;
                        this.validationMessage = '下限警報は　数字、記号「.」「-」　のみ使用できます。';
                        this.scrollTop();
                        return null;
                    }
                    if(!this.checkStrong2(senserDataList[k].upper_dead_zone_temperature) || !this.checkStrong2(senserDataList[k].upper_dead_zone_humidity)){
                        this.isLoading = false;
                        this.validationMessage = '上限警報リセットは 数字、記号「.」「-」 のみ使用できます。';
                        this.scrollTop();
                        return null;
                    }
                    if(!this.checkStrong2(senserDataList[k].lower_dead_zone_temperature) || !this.checkStrong2(senserDataList[k].lower_dead_zone_humidity)){
                        this.isLoading = false;
                        this.validationMessage = '下限警報リセットは 数字、記号「.」「-」 のみ使用できます。';
                        this.scrollTop();
                        return null;
                    }
                    if(!this.checkStrong3(senserDataList[k].duration) || !this.checkStrong3(senserDataList[k].duration_humidity)){
                        this.isLoading = false;
                        this.validationMessage = '継続時間は　数字のみ使用できます。';
                        this.scrollTop();
                        return null;
                    }
                }
            }

            //桁数チェック
            for(var p = 0 ; p < senserDataList.length ; p++) {

                if(String(senserDataList[p].sensor_kbn_name).length > 10){
                    this.validationMessage = "種別は10桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].upper_temperature).length > 5){
                    this.validationMessage = "上限警報は5桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].upper_dead_zone_temperature).length > 5){
                    this.validationMessage = "上限警報リセットは5桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].lower_temperature).length > 5){
                    this.validationMessage = "下限警報は5桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].lower_dead_zone_temperature).length > 5){
                    this.validationMessage = "下限警報リセットは5桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].duration).length > 4){
                    this.validationMessage = "継続時間(分)は4桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }

                if(String(senserDataList[p].upper_humidity).length > 5){
                    this.validationMessage = "上限警報は5桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].upper_dead_zone_humidity).length > 5){
                    this.validationMessage = "上限警報リセットは5桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].lower_humidity).length > 5){
                    this.validationMessage = "下限警報は5桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].lower_dead_zone_humidity).length > 5){
                    this.validationMessage = "下限警報は5桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
                if(String(senserDataList[p].duration_humidity).length > 4){
                    this.validationMessage = "継続時間(分)は4桁で入力してください。";
                    this.isLoading = false;
                    this.scrollTop();
                    return null;
                }
            }

            // 小数点の形式チェック
            for(var l = 0 ; l < senserDataList.length ; l++) {

                // 桁数(小数点)チェック
                // 温度 上限警報
                if(senserDataList[l].upper_temperature !== '' && senserDataList[l].upper_temperature !== null &&
                    senserDataList[l].upper_temperature.indexOf('.') !== -1){
                    var arrayUpperTemperature = senserDataList[l].upper_temperature.toString().split('.');
                    if(arrayUpperTemperature[1].length > 1){
                        this.validationMessage="温度の上限警報は、小数点第1位まで入力してください。";
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 温度 下限警報
                if(senserDataList[l].lower_temperature !== '' && senserDataList[l].lower_temperature !== null &&
                    senserDataList[l].lower_temperature.indexOf('.') !== -1){
                    var arraylowerTemperature = senserDataList[l].lower_temperature.toString().split('.');
                    if(arraylowerTemperature[1].length > 1){
                        this.validationMessage="温度の下限警報は、小数点第1位まで入力してください。";
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 温度 上限警報リセット
                if(senserDataList[l].upper_dead_zone_temperature !== '' && senserDataList[l].upper_dead_zone_temperature !== null &&
                    senserDataList[l].upper_dead_zone_temperature.indexOf('.') !== -1){
                    var arrayUpperDeadZoneTemperature = senserDataList[l].upper_dead_zone_temperature.toString().split('.');
                    if(arrayUpperDeadZoneTemperature[1].length > 1){
                        this.validationMessage="温度の上限警報リセットは、小数点第1位まで入力してください。";
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 温度 下限警報リセット
                if(senserDataList[l].lower_dead_zone_temperature !== '' &&  senserDataList[l].lower_dead_zone_temperature !== null
                    && senserDataList[l].lower_dead_zone_temperature.indexOf('.') !== -1){
                    var arraylowerDeadZoneTemperature = senserDataList[l].lower_dead_zone_temperature.toString().split('.');
                    if(arraylowerDeadZoneTemperature[1].length > 1){
                        this.validationMessage="温度の下限警報リセットは、小数点第1位まで入力してください。";
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }

            }

            // 範囲チェック
            for(var s = 0 ; s < senserDataList.length ; s++) {
                // 温度 上限警報
                if(senserDataList[s].upper_temperature !== '' && senserDataList[s].upper_temperature !== null){
                    if(!this.checkRangeTemperature(senserDataList[s].upper_temperature,"upper_temperature")){
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 温度 上限警報リセット
                if(senserDataList[s].upper_dead_zone_temperature !== '' && senserDataList[s].upper_dead_zone_temperature !== null){
                    if(!this.checkRangeTemperature(senserDataList[s].upper_dead_zone_temperature,"upper_dead_zone_temperature")){
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 温度 下限警報リセット
                if(senserDataList[s].lower_dead_zone_temperature !== '' && senserDataList[s].lower_dead_zone_temperature !== null){
                    if(!this.checkRangeTemperature(senserDataList[s].lower_dead_zone_temperature,"lower_dead_zone_temperature")){
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 温度 下限警報
                if(senserDataList[s].lower_temperature !== '' && senserDataList[s].lower_temperature !== null) {
                    if(!this.checkRangeTemperature(senserDataList[s].lower_temperature,"lower_temperature")){
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }

                // 湿度 上限警報
                if(senserDataList[s].upper_humidity !== '' && senserDataList[s].upper_humidity !== null ){
                    if(!this.checkRangeumidity(senserDataList[s].upper_humidity,"upper_humidity")){
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 湿度 上限警報リセット
                if(senserDataList[s].upper_dead_zone_humidity !== '' && senserDataList[s].upper_dead_zone_humidity !== null ){
                    if(!this.checkRangeumidity(senserDataList[s].upper_dead_zone_humidity,"upper_dead_zone_humidity")){
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 湿度 下限警報リセット
                if(senserDataList[s].lower_dead_zone_humidity !== '' && senserDataList[s].lower_dead_zone_humidity !== null ){
                    if(!this.checkRangeumidity(senserDataList[s].lower_dead_zone_humidity,"lower_dead_zone_humidity")){
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
                // 湿度 下限警報
                if(senserDataList[s].lower_humidity !== '' && senserDataList[s].lower_humidity !== null ){
                    if(!this.checkRangeumidity(senserDataList[s].lower_humidity,"lower_humidity")){
                        this.isLoading = false;
                        this.scrollTop();
                        return ;
                    }
                }
            }


            //正常時、API呼び出し
            // 機器閾値情報更新APIの呼び出し
            var brandId = this.$store.getters['brand/id'];
            var url = this.$apiEndpoint + 'manage/brand/' + brandId + '/measuring_instruments_threshold/setting';

            //更新API呼び出し
            await this.$axios
                .post(url, {sensorKbnSettings:this.senserSettingData})
                .then()
                .catch((err) => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    apiResponseFlg = false;
                    if (err.customError) {
                        error = Object.assign(error, err.customError);

                        if(error.code == 400){
                            this.validationMessage =  error.message;
                            this.scrollTop();
                        }
                    }
                    if(error.code !== 400){
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                }).finally(()=> this.isLoading = false);

            // 処理エラーがない場合
            if(apiResponseFlg){
                this.showContent = true;
            }

        },
        clearError:function(){
            //メッセージ初期化
            this.validationMessage = ""
        },
        //英数漢ひらカタのチェック
        checkStrong:function(inputdata){
            var re = new RegExp(ValidationRule.ZenHankakuEiSuuKanaKanji);
            return re.test(inputdata);
        },
        //数字、記号「.」「-」 のチェック
        checkStrong2:function(inputdata){
            if(!inputdata){
                return true;
            }

            const re = new RegExp(/^[-]?([1-9]\d*|0)(\.\d+)?$/);
            return re.test(inputdata);
        },
        //数字のチェック
        checkStrong3:function(inputdata){
            if(!inputdata){
                return true;
            }

            const re = new RegExp(/^[0-9]*$/);
            return re.test(inputdata);
        },
        // 範囲チェック 温度
        checkRangeTemperature:function(temperatureValue,type){

            if(temperatureValue > 409.5){
                if(type == "upper_temperature"){
                    this.validationMessage="温度上限警報には、409.5以下の数字を指定してください。";
                }
                else if(type == "upper_dead_zone_temperature"){
                    this.validationMessage="温度上限警報リセットには、409.5以下の数字を指定してください。";
                }
                else if(type == "lower_dead_zone_temperature"){
                    this.validationMessage="温度下限警報リセットには、409.5以下の数字を指定してください。";
                }
                else if(type == "lower_temperature"){
                    this.validationMessage="温度下限警報には、409.5以下の数字を指定してください。";
                }
                return false;
            }
            else if(temperatureValue < -99.9 ){

                if(type == "upper_temperature"){
                    this.validationMessage="温度上限警報には、-99.9以上の数字を指定してください。";
                }
                else if(type == "upper_dead_zone_temperature"){
                    this.validationMessage="温度上限警報リセットには、-99.9以上の数字を指定してください。";
                }
                else if(type == "lower_dead_zone_temperature"){
                    this.validationMessage="温度下限警報リセットには、-99.9以上の数字を指定してください。";
                }
                else if(type == "lower_temperature"){
                    this.validationMessage="温度下限警報には、-99.9以上の数字を指定してください。";
                }
                return false;
            }
            return true;
        },
        // 範囲チェック 湿度
        checkRangeumidity:function(humidityValue,type){
            if(humidityValue > 100){
                if(type == "upper_humidity"){
                    this.validationMessage="湿度上限警報には、100以下の数字を指定してください。";
                }
                else if(type == "upper_dead_zone_humidity"){
                    this.validationMessage="湿度上限警報リセットには、100以下の数字を指定してください。";
                }
                else if(type == "lower_dead_zone_humidity"){
                    this.validationMessage="湿度下限警報リセットには、100以下の数字を指定してください。";
                }
                else if(type == "lower_humidity"){
                    this.validationMessage="湿度下限警報には、100以下の数字を指定してください。";
                }
                return false;
            }
            else if(humidityValue < 0 ){

                if(type == "upper_humidity"){
                    this.validationMessage="湿度上限警報には、0以上の数字を指定してください。";
                }
                else if(type == "upper_dead_zone_humidity"){
                    this.validationMessage="湿度上限警報リセットには、0以上の数字を指定してください。";
                }
                else if(type == "lower_dead_zone_humidity"){
                    this.validationMessage="湿度下限警報リセットには、0以上の数字を指定してください。";
                }
                else if(type == "lower_humidity"){
                    this.validationMessage="湿度下限警報には、0以上の数字を指定してください。";
                }
                return false;
            }
            return true;

        },
        closeModel() {
            this.showContent = false;
            this.$router.push({name: 'managemenu'});
        },
        scrollTop() {
            window.scrollTo(0,0);
        }
    }
}
</script>